import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';

const ROLES = {
  ADMIN: 'ADMIN',
  DATA_MANAGER: 'DATA_MANAGER',
  LOGISTICS_COORDINATOR: 'LOGISTICS_COORDINATOR',
  AREA_COORDINATOR: 'AREA_COORDINATOR',
  CLIENT: 'CLIENT',
};

const PERMISSIONS = {
  CREATE_SERVICE_LEVEL: 'service_level_add',
  EDIT_SERVICE_LEVEL: 'service_level_change',
  DELETE_SERVICE_LEVEL: 'service_level_delete',
  VIEW_SERVICE_LEVEL: 'service_level_view'
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_SERVICE_LEVEL,
    PERMISSIONS.EDIT_SERVICE_LEVEL,
    PERMISSIONS.DELETE_SERVICE_LEVEL,
    PERMISSIONS.VIEW_SERVICE_LEVEL
  ],
  [ROLES.DATA_MANAGER]: [
    PERMISSIONS.VIEW_SERVICE_LEVEL
  ],
  [ROLES.LOGISTICS_COORDINATOR]: [
    PERMISSIONS.EDIT_SERVICE_LEVEL,
    PERMISSIONS.VIEW_SERVICE_LEVEL
  ],
  [ROLES.AREA_COORDINATOR]: [
    PERMISSIONS.EDIT_SERVICE_LEVEL,
    PERMISSIONS.VIEW_SERVICE_LEVEL
  ],
  [ROLES.CLIENT]: [
    PERMISSIONS.VIEW_SERVICE_LEVEL
  ]
};

const usePermissions = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasPermission = (permission) => {
    if (!user?.role?.name) return false;
    return ROLE_PERMISSIONS[user.role.name]?.includes(permission) || false;
  };

  const can = {
    createServiceLevel: () => hasPermission(PERMISSIONS.CREATE_SERVICE_LEVEL),
    editServiceLevel: () => hasPermission(PERMISSIONS.EDIT_SERVICE_LEVEL),
    deleteServiceLevel: () => hasPermission(PERMISSIONS.DELETE_SERVICE_LEVEL),
    viewServiceLevel: () => hasPermission(PERMISSIONS.VIEW_SERVICE_LEVEL)
  };

  return {
    loading,
    error,
    can,
    ROLES,
    PERMISSIONS
  };
};

export default usePermissions;
